






































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    NavbarDark,
    Footer,
  },
})
export default class Productos extends Vue {
  public data() {
    return {
      title: 'El primer paso para la sonrisa de tus sueños',
      subtitle: 'Nuestra línea de productos Toothly te dará lo que necesitas para iniciar el cambio.',
      productos: [
        { image: 'blanqueamiento',
          color: 'background-color: #FED5C5;',
          title: 'Kit premium de blanqueamiento dental Toothly',
          descriptionOne: '1 guarda duplex de blanqueamiento con acelerador de luz LED de 16 bulbos',
          descriptionTwo: '3 plumas de 2ml de gel para blanqueamiento dental',
          link: '/kit-blanqueamiento',
          cta: 'Quiero mi kit',
        },
        { image: 'impresion',
          color: 'background-color: #EEECE4;',
          title: 'Kit de impresiones dentales Toothly',
          descriptionOne: 'Cucharilla de impresión superior',
          descriptionTwo: 'Cucharilla de impresión inferior',
          descriptionThree: '3 sets de material para impresiones: catalizador y base',
          link: '/eres-candidato',
          cta: '¿Soy candidato?',
        },
      ],
    };
  }
}
